import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PopupComponent } from 'src/app/extensions/components/popup/popup.component';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { ClientDataRequestTypeEnum } from 'src/app/models/ClientDataEnums';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-client-data-request-preview',
  templateUrl: './client-data-request-preview.component.html',
  styleUrl: './client-data-request-preview.component.scss',
  standalone: false,
})
export class ClientDataRequestPreviewComponent implements OnInit {
  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel;
  isRequestSaved: boolean;
  routePath: string;
  isPJ = true;
  requestType: app.models.ClientDataRequestType;
  clientDataRequestType = ClientDataRequestTypeEnum;
  maritalStatus: string;
  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _requestService: RequestAPIService,
    private _dictionaryService: DictionaryAPIService,
    private _ngbModal: NgbModal,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
      this.isPJ = this.stateSignalItem.extras?.isPJ ?? this.isPJ;
      this.routePath = this.stateSignalItem.routePath;
    } else {
      this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, undefined);
      this.redirectRequestTypeHandler();
    }
  }

  ngOnInit(): void {
    this._dictionaryService
      .getClientDataRequestTypes()
      .pipe(
        map(res => {
          return res.data.find(x => x.id === this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId);
        }),
        switchMap(requestType => {
          const maritalStatus$ =
            requestType?.code === this.clientDataRequestType.PersonalInfo
              ? this._dictionaryService
                  .getMaritalStatuses()
                  .pipe(
                    map(maritalStatusRes =>
                      maritalStatusRes.data.find(
                        x =>
                          x.id === this.clientDataRequestSaveModel.personalInformation.dictionaryPersonMaritalStatusId
                      )
                    )
                  )
              : of(null);
          return forkJoin({ requestType: of(requestType), maritalStatus: maritalStatus$ });
        })
      )
      .subscribe(res => {
        this.requestType = res.requestType;
        if (res.maritalStatus) {
          this.maritalStatus = res.maritalStatus.value;
        }
      });
  }

  redirectFieldSelectionHandler() {
    this._router.navigate([`requests/client-data/new/${this.routePath}`]);
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };

  redirectRequestTypeHandler = () => {
    this._router.navigate(['requests/client-data/new']);
  };

  sendRequestCofirmationHandler() {
    if (this.requestType.code !== this.clientDataRequestType.Address) {
      this.saveRequestHandler();
      return;
    }
    const modal = this._ngbModal.open(PopupComponent);
    modal.componentInstance.title = 'requests.clientData.modal.text';
    modal.componentInstance.description = 'requests.clientData.modal.descriptionAddress';
    modal.result.then(result => {
      if (result) {
        this.saveRequestHandler();
      }
    });
  }

  saveRequestHandler() {
    this._requestService.saveClientDataRequest(this.clientDataRequestSaveModel).subscribe(result => {
      if (result.isSuccess) {
        this.isRequestSaved = true;
        this._notificationService.showSuccess(
          this._translateService.instant('requests.clientData.notification.requestSaved'),
          this._translateService.instant('common.success')
        );
      }
    });
  }
}
